import { makeStyles } from "@material-ui/core";

export const useTabStyles = makeStyles((theme) => ({
    tabContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto'
    },
    tabsContainer: {
        flex: '0 0 auto',
        background: 'none',
        boxShadow: 'none',
        "& .Mui-selected": {
        }
    },
    swipeDiv: {
        height: '100%',
    },
    tabContent: {
        flex: '0 1 auto',
        position: 'relative',
        overflow: 'auto',
        height: '100%'
    }

}));
